import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RegistryService} from "../../../../services/registry.service";
import {CartService} from "../../../../services/cart.service";
import {Product} from "../../../../models/product";
import {ProductDataSet} from "../../../../models/product-data-set";
import {ProductService} from "../../../../services/product.service";
import {WishlistService} from "../../../../services/wishlist.service";
import {environment} from "../../../../../../environments/environment";
import {MatSnackBar} from '@angular/material/snack-bar';
import {GoogleAnalyticsService} from "../../../../services/google-analytics.service";
import {ProductOptionsService} from "../../product-details/product-options/product-options.service";

@Component({
    selector: 'app-product-information-qr',
    templateUrl: './product-information-qr.component.html',
    styleUrls: ['./product-information-qr.component.css']
})
export class ProductInformationQrComponent implements OnInit, OnDestroy {
    @Input() product: Product;

    env = environment;
    hasSpecialPrice = false;

    configurableProductOptions: Product[] = [];
    isAdding = false;
    qty = 1;
    tempQty = 0;
    qtyUpdatedEvent;


    constructor(public registry: RegistryService,
                public cartService: CartService,
                private googleService: GoogleAnalyticsService,
                public productService: ProductService,
                public productOptionService: ProductOptionsService,
                public wishListService: WishlistService,
                private snackBar: MatSnackBar
    ) {

        this.qtyUpdatedEvent = cartService.QtyUpdatedEvent$.subscribe(qty => {
            this.qty = qty;
        });

    }


    ngOnInit(): void {

        this.hasSpecialPrice = this.product.hasSpecialPrice();

        this.getConfigurableProductOptions();

        this.productOptionService.optionItemSelectedEvent.subscribe(product => {

            this.product = product;

        });

    }

    ngOnDestroy(): void {
        this.qtyUpdatedEvent.unsubscribe();
    }

    addItemToWishlist(event) {

        event.preventDefault();
        this.wishListService.addWishlistItem(this.product.sku).subscribe(result => {


            this.googleService.eventEmitter("add_to_wishlist", 'shop', 'cart', 'click', 10);

        });
    }


    addItemToCart() {

        this.isAdding = true;
        let cartId = localStorage.getItem('cartId');
        this.cartService.addItemToCart(this.registry.cart, this.product.sku, this.qty).subscribe(resp => {


                let ctype = localStorage.getItem('customer_type');

                if (ctype == 'guest') {
                    this.cartService.getGuestCart(this.cartService.cart.quoteId,this.registry.getWebsiteId()).subscribe(cart => {
                        cart.cartType = 'guest';
                        cart.quoteId = cartId;
                        this.registry.cart = cart;
                        this.cartService.cart = cart;
                        this.cartService.EmitCartUpdated(cart);
                        this.isAdding = false;
                        this.googleService.eventEmitter("add_to_cart", 'ecommerce', 'add_to_cart', this.product.name + "-" + this.product.sku, this.product.price);
                    });
                } else {
                    //user
                    this.cartService.getCustomerCart(this.registry.getWebsiteId()).subscribe(cart => {

                        cart.cartType = 'user';
                        cart.quoteId = cartId;
                        this.registry.cart = cart;
                        this.cartService.cart = cart;
                        this.cartService.EmitCartUpdated(cart);
                        this.isAdding = false;
                        this.googleService.eventEmitter("add_to_cart", 'ecommerce', 'add_to_cart', this.product.name + "-" + this.product.sku, this.product.price);

                    });
                }

            },
            error => {
                this.openSuccessSnackBar("There was an error adding item to cart", "OK");
                this.isAdding = false;

            }
        );

    }

    newValue(value) {
        this.qty = value;
        this.cartService.EmitQtyUpdated(this.qty);

    }

    getConfigurableProductOptions() {

        //console.log(this.item.getExtentionAttByKey('configurable_product_links'));
        if (this.product.extension_attributes.configurable_product_links) {
            let cs = this.product.extension_attributes.configurable_product_links.toString();
            let dataset = new ProductDataSet();
            dataset.pushParams('entity_id', cs, 'in');
            this.productService.ProductSearchAdv('entity_id', cs, 'in', 1,this.registry.getWebsiteId()).subscribe(result => {

                this.configurableProductOptions = result.items.map(item => Object.assign(new Product, item));

            });
        }

    }

    // Snackbar that opens with success background
    openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
            horizontalPosition: "right",
            panelClass: ['primary-snackbar'],
        });
    }


}
